import { PHONE_TYPE_FAX } from '../PhoneTypeField/constants';
export default function phoneCanReceiveOralCommunication() {
  var phoneType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return phoneType !== PHONE_TYPE_FAX;
}
//# sourceMappingURL=phoneCanReceiveOralCommunication.js.map